import React, { ReactElement } from 'react';
import { kebabCase } from 'lodash/fp';

// Components
import FloatingPanel from '../../../../components/tooltips/FloatingPanel';
import CellTypeFormatContent from './CellTypeFormatContent';
import PopupPanelMouseManager from '../../../../components/popupPanel/PopupPanelMouseManager';

// Constants
import { CellTypeNames } from '../../../../../common/table/CellTypeConstants';
import { TooltipAlignment, TooltipPositions } from '../../../../components/tooltips/tooltipConstants';
import { PopupIds } from '../../../../components/popupPanel/popupConstants';
import { CellTypeFormatChanges, CellTypeObjectWithAuto } from '../../../../../common/table/TableTypes';

type Props = {
    showFormattingOptions: boolean;
    currentCellType: CellTypeNames;
    updateCellTypeFormat: (cellTypeFormatChanges: CellTypeFormatChanges) => void;
    sharedCellTypeFormatOptions?: CellTypeObjectWithAuto;
    locale: string;
};

const CellTypeFormatPopup: React.FC<Props> = (props): ReactElement => {
    const { showFormattingOptions, currentCellType } = props;

    return (
        <FloatingPanel
            className="CellTypeFormattingOptionsPopup light"
            selector={`.CellTypePopup .CellTypeButton.${kebabCase(currentCellType)}`}
            pollPosition
            offset={20}
            arrowWidth={0}
            distance={-4}
            alignment={TooltipAlignment.START}
            position={TooltipPositions.RIGHT}
        >
            <PopupPanelMouseManager
                {...props}
                visible={showFormattingOptions}
                popupId={PopupIds.CELL_TYPE_FORMATTING_OPTIONS}
                closePopup={() => {}}
            >
                <CellTypeFormatContent {...props} currentCellType={currentCellType} formSize="sm" />
            </PopupPanelMouseManager>
        </FloatingPanel>
    );
};

export default CellTypeFormatPopup;
